/**
 * Logout Command
 * Clear stored authentication credentials
 */

import { Command } from 'commander';
import { createInterface } from 'readline';
import { logout } from '../api/auth.js';
import { revokeAllOtherDevices } from '../api/devices.js';
import { isAuthenticated, getConfigValue } from '../utils/config.js';
import * as output from '../utils/output.js';

export const logoutCommand = new Command('logout')
  .description('Sign out of Paean AI')
  .option('--force', 'Force logout without confirmation')
  .option('--all', 'Also revoke all other device sessions')
  .action(async (options) => {
    if (!isAuthenticated()) {
      output.info('Not currently logged in.');
      return;
    }

    const email = getConfigValue('email');

    if (!options.force) {
      output.warning(`You are about to sign out${email ? ` from ${email}` : ''}.`);
      output.dim('This will clear your stored credentials.');
      output.newline();

      // Real confirmation prompt
      const rl = createInterface({ input: process.stdin, output: process.stdout });
      const answer = await new Promise<string>((resolve) => {
        rl.question('  Sign out? (y/n): ', resolve);
      });
      rl.close();

      if (answer.toLowerCase() !== 'y' && answer.toLowerCase() !== 'yes') {
        output.info('Logout cancelled.');
        return;
      }
    }

    if (options.all) {
      try {
        await revokeAllOtherDevices();
        output.dim('All other device sessions have been revoked.');
      } catch {
        // Best effort
      }
    }

    logout();
    output.success('Successfully logged out.');
    output.dim('Use "paean login" to sign in again.');
  });
